import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AuditDialog = /*#__PURE__*/function (_Vue) {
  _inherits(AuditDialog, _Vue);

  var _super = _createSuper(AuditDialog);

  function AuditDialog() {
    var _this;

    _classCallCheck(this, AuditDialog);

    _this = _super.apply(this, arguments);
    _this.model = false;
    _this.newCaseInput = {
      name: '',
      gender: '',
      birthday: '',
      phone: '',
      memo: ''
    };
    return _this;
  }

  _createClass(AuditDialog, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      return false;
    }
  }, {
    key: "cancelDialog",
    value: function cancelDialog() {
      this.closeDialog();
    }
  }, {
    key: "valueChanged",
    value: function valueChanged() {
      this.model = this.value;
    }
  }, {
    key: "rejectDialog",
    value: function rejectDialog() {}
  }, {
    key: "passDialog",
    value: function passDialog() {}
  }]);

  return AuditDialog;
}(Vue);

__decorate([Prop(Boolean)], AuditDialog.prototype, "value", void 0);

__decorate([Prop(Boolean)], AuditDialog.prototype, "showAction", void 0);

__decorate([Emit('input')], AuditDialog.prototype, "closeDialog", null);

__decorate([Emit('cancel')], AuditDialog.prototype, "cancelDialog", null);

__decorate([Watch('value')], AuditDialog.prototype, "valueChanged", null);

__decorate([Emit('reject')], AuditDialog.prototype, "rejectDialog", null);

__decorate([Emit('pass')], AuditDialog.prototype, "passDialog", null);

AuditDialog = __decorate([Component], AuditDialog);
export default AuditDialog;